import { Select } from '@legion-ui/core';

type OptionType = {
  label: string;
  value: 'username' | 'email';
};

type PageHeaderProps = {
  title?: string;
  searchTerm?: string;
  handleSearchChange?: (e: React.KeyboardEvent<HTMLInputElement>, searchBy: 'username' | 'email') => void;
  handleSearchClear?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showSearch?: boolean;
  searchBy?: OptionType;
  setSearchBy?: (option: OptionType) => void;
};

const PageHeader = ({
  title,
  searchTerm,
  handleSearchChange,
  handleSearchClear,
  showSearch = false,
  searchBy,
  setSearchBy,
}: PageHeaderProps) => {
  const searchOptions: OptionType[] = [
    { label: 'Username', value: 'username' },
    { label: 'Email', value: 'email' },
  ];

  return (
    <div className="flex flex-wrap justify-between items-start mt-6">
      {showSearch && searchBy && setSearchBy && (
        <div className="w-full sm:w-auto order-1 sm:order-first">
          <div className="flex flex-row items-start gap-4 flex-wrap">
            {/* Input + Press Enter */}
            <div className="flex flex-col justify-start">
              <label className="text-sm text-gray-600 font-medium mb-1">Search</label>
              <input
                type="text"
                placeholder={`Search Exact ${searchBy.label}...`}
                defaultValue={searchTerm}
                onKeyDown={(e) => handleSearchChange?.(e, searchBy.value)}
                onChange={handleSearchClear}
                className="px-4 py-2 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 min-w-[250px] transition-colors duration-200"
              />
              <small className="text-xs text-gray-500 mt-1">
                Press <strong className="text-blue-600">Enter</strong> to Search
              </small>
            </div>

            {/* Select + Label */}
            <div className="flex flex-col justify-start">
              <label className="text-sm text-gray-600 font-medium mb-1">Search By</label>
              <Select
                options={searchOptions}
                value={[searchBy]}
                onChange={(value) => {
                  const selected = value[0];
                  if (selected) setSearchBy(selected);
                }}
                className="w-[160px]"
                size="md"
              />
              <div className="h-[21px]"></div> {/* agar sama tinggi dengan small di input */}
            </div>
          </div>
        </div>
      )}
      
      {title && (
        <div className="order-2 sm:order-last">
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        </div>
      )}
    </div>
  );
};

export default PageHeader;
